import React from "react";
import { MdOutlineWavingHand, MdThumbUpOffAlt } from "react-icons/md";
const GetStarted = ({ quizStarterHandler }) => {
  return (
    <div
      className="container mt-5 mb-5 d-flex justify-content-center align-items-center"
      id="start"
      style={{ height: "80vh" }}
    >
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="text-center">
            <div
              className="icon d-flex align-items-center justify-content-center bg-soft-primary rounded-circle mx-auto"
              style={{ height: "90px", width: "90px" }}
            >
              <MdOutlineWavingHand className=" align-middle h1 mb-0" />
            </div>
            <h1 className="my-4 fw-bold">Welcome</h1>
            <p className="text-muted para-desc mx-auto">
              ProfBot does not judge your answers. Nor is your conversation
              recorded. ProfBot does not share your success with your professor.
              ProfBot is entirely optional. You may stop using ProfBot by
              closing your browser.
            </p>
            <a
              onClick={() => quizStarterHandler(true)}
              className="btn btn-soft-primary mt-3"
            >
              Start the test
            </a>
          </div>
        </div>
        {/*end col*/}
      </div>
      {/*end row*/}
    </div>
  );
};

export default GetStarted;
